import { getFormData } from "components/utils/comm";
import { FormEvent } from "react";
import { useLocation } from "react-router-dom";
import useAlertStore from "store/alert";
import { useJoinCreateMutate } from "./service";
import { IJoinProps } from "interface/member";

// 전체 체크
export const onAllCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
  const checked = e.currentTarget.checked;
  const checkboxs = document.querySelectorAll(
    "[type='checkbox']"
  ) as NodeListOf<HTMLInputElement>;
  if (checked) {
    checkboxs.forEach((checkbox: HTMLInputElement) => {
      checkbox.checked = true;
    });
  }
  if (!checked) {
    checkboxs.forEach((checkbox: HTMLInputElement) => {
      checkbox.checked = false;
    });
  }
};

//체크 박스 체크
export const onCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
  const checked = e.currentTarget.checked;
  e.currentTarget.checked = checked ? true : false;
  let checkboxs = document.querySelectorAll(
    "[type='checkbox']"
  ) as NodeListOf<HTMLInputElement>;

  let checks = Array.from(checkboxs).slice(1, 5);

  const isAll = checks.every((check) => {
    return check.checked;
  });

  let all = document.getElementById("all") as HTMLInputElement;

  all.checked = isAll;
};

// 회원가입
export const useJoinCreate = () => {
  const onSetAler = useAlertStore((state) => state.onSetAlert);
  const { mutate } = useJoinCreateMutate();
  const { state } = useLocation();
  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    // ❌ validation 실패
    if (!form.checkValidity()) {
      form.reportValidity(); // required 문구 표시
      return;
    }

    onSetAler({
      isOpen: true,
      inner: "회원가입을 진행하시겠습니까?",
      cnclBtn: true,
      onSetConfirm: () => {
        const formData = getFormData({ form, type: "C" });

        const { lgnPwd, ...data } = formData;

        const prvList = Object.keys(data).map((key, index) => {
          const prvAgYn: string = data[key];
          return {
            prvGrpCd: key,
            prvSeq: index + 1 + "",
            required: true,
            prvAgYn,
          };
        });

        const params: IJoinProps = {
          lgnPwd: lgnPwd,
          certEncParam: state?.certEncParam ?? undefined,
          prvList: prvList,
        };
        mutate(params);
      },
    });
  };

  return {
    onSubmit,
  };
};
